import SettingsView from "../components/entityViews/settings/SettingsView";

export const SettingsPage = () => {
  return (
    <div className="relative flex flex-1 bg-background h-full w-full min-w-0" id="settings-page">
      <SettingsView />
    </div>
  );
};

export default SettingsPage;
